import { css, unsafeCSS } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    section.add-to-cart {
      display: flex;
      flex-direction: column;
    }

    .content-wrapper-header {
      height: calc(24rem / var(--default-rem-px-count));
      padding-bottom: calc(8rem / var(--default-rem-px-count));
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .close-modal {
      height: calc(12rem / var(--default-rem-px-count));
      cursor: pointer;
    }

    .close-modal img {
      height: calc(24rem / var(--default-rem-px-count));
    }

    .added-to-cart {
      font-weight: 500;
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .content-wrapper > div {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
    }

    .image-wrapper {
      display: flex;
    }

    .image-wrapper img {
      max-width: 100%;
      max-height: 40vh;
      margin: auto;
    }

    .details-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .price {
      padding-top: calc(24rem / var(--default-rem-px-count));
    }

    .sample-limit {
      margin-top: auto;
    }

    .contact-rep,
    .contact-rep:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    .ctas-wrapper {
      display: flex;
      flex-direction: row;
      padding-top: calc(40rem / var(--default-rem-px-count));
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .ctas-wrapper > cta-button {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
      max-width: calc(50% - calc(7rem / var(--default-rem-px-count)));
    }

    .login-content {
      display: flex;
      flex-direction: column;
      padding-bottom: calc(10rem / var(--default-rem-px-count));
    }

    .login-content > cta-text {
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    form.login {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
      padding: calc(14rem / var(--default-rem-px-count)) 0;
    }

    form.login .inputs {
      display: flex;
      flex-direction: row;
      gap: calc(14rem / var(--default-rem-px-count));
      padding-top: calc(40rem / var(--default-rem-px-count));
    }

    form.login .inputs > span {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
    }

    .input-wrapper {
      position: relative;
      background-color: #dddddd;
    }

    .submit-wrapper {
      padding-top: calc(14rem / var(--default-rem-px-count));
    }

    /* Override browser defaults */
    .input-wrapper input {
      -webkit-appearance: none;
      outline: none;
      box-shadow: none;
      border: none;
      padding: 0;
    }

    .input-wrapper input {
      display: block;
      width: calc(100% - calc(16rem / var(--default-rem-px-count)));
      height: calc(44rem / var(--default-rem-px-count));
      padding-left: calc(16rem / var(--default-rem-px-count));
      padding-top: calc(7rem / var(--default-rem-px-count));
    }

    label.input-label {
      position: absolute;
      top: calc(14rem / var(--default-rem-px-count));
      left: calc(16rem / var(--default-rem-px-count));
      transition: 0.4s ease all;
      font-size: calc(14rem / var(--default-rem-px-count));
      font-weight: 400;
      letter-spacing: -0.21;
      line-height: calc(20rem / var(--default-rem-px-count));
      pointer-events: none;
    }

    input:focus ~ label.input-label,
    input:valid ~ label.input-label,
    input ~ label.input-label.valid {
      font-size: calc(10rem / var(--default-rem-px-count));
      top: 0px;
    }

    label.input-label.invalid.touched {
      color: red;
      top: 0px;
      font-size: calc(10rem / var(--default-rem-px-count));
    }

    input.visited ~ label.input-label {
      color: red;
    }

    .description {
      font-size: calc(14rem / var(--default-rem-px-count));
      letter-spacing: -0.24px;
      line-height: calc(24rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .content-wrapper {
        flex-direction: row;
      }

      .image-wrapper img {
        width: 100%;
        max-width: unset;
        max-height: unset;
        margin: unset;
      }
    }
  `,
];
